import React from 'react';
import Icon from '../../../components/AppIcon';

const ProjectMetadataCard = ({ project }) => {
  const metadataFields = [
    {
      label: 'País',
      value: project?.country || 'N/A',
      icon: 'MapPin',
      color: 'var(--color-primary)'
    },
    {
      label: 'Tipo de Proyecto',
      value: project?.projectType || 'N/A',
      icon: 'TreePine',
      color: 'var(--color-accent)'
    },
    {
      label: 'Estándar',
      value: project?.standard || 'N/A',
      icon: 'Award',
      color: 'var(--color-success)'
    },
    {
      label: 'Estado',
      value: project?.status || 'N/A',
      icon: 'Activity',
      color: 'var(--color-warning)'
    },
    {
      label: 'Área Total',
      value: project?.totalArea ? `${project?.totalArea?.toLocaleString('es-ES')} ha` : 'N/A',
      icon: 'Maximize2',
      color: 'var(--color-secondary)'
    },
    {
      label: 'Fecha de Inicio',
      value: project?.startDate ? new Date(project.startDate)?.toLocaleDateString('es-ES') : 'N/A',
      icon: 'Calendar',
      color: 'var(--color-muted-foreground)'
    }
  ];

  return (
    <div className="card">
      <div className="flex items-center gap-3 mb-6">
        <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-lg">
          <Icon name="Info" size={20} color="var(--color-primary)" />
        </div>
        <h2 className="text-xl font-semibold font-mono">Información del Proyecto</h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {metadataFields?.map((field, index) => (
          <div
            key={index}
            className="p-4 bg-background rounded-lg border border-border hover:border-primary/20 transition-all duration-250"
          >
            <div className="flex items-start gap-3">
              <div
                className="flex items-center justify-center w-8 h-8 rounded-md flex-shrink-0"
                style={{ backgroundColor: `${field?.color}15` }}
              >
                <Icon name={field?.icon} size={16} color={field?.color} />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-xs text-muted-foreground caption mb-1">
                  {field?.label}
                </p>
                <p className="text-sm font-medium text-foreground truncate">
                  {field?.value}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
      {project?.description && (
        <div className="mt-6 pt-6 border-t border-border">
          <h3 className="text-sm font-medium text-foreground mb-3">Descripción</h3>
          <p className="text-sm text-muted-foreground leading-relaxed">
            {project?.description}
          </p>
        </div>
      )}
    </div>
  );
};

export default ProjectMetadataCard;